<template>
  <div>

    <div class="mb-3 windows-like-breadcrumb-card shadow-sm">
      <ProductCategoriesDataList :enableRowSelection="false"/>
    </div>
  </div>
</template>

<script>
import ProductCategoriesDataList from "./ProductCategoriesDataList.vue";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

export default {
  name: "ProductCategoriesStage",
  components: {
    ProductCategoriesDataList
  },
  computed: {
        simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {
  },
  mounted() {
    this.commonModule.setHorizontalNavbarTitle(`<i class="bx bx-home-circle me-1"></i> Kategorie`)
  }
};
</script>

<style scoped>
.top-space {
  margin-top: 8px;
}
</style>
